import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      Swal.fire("Error", "Please fill in both email and password.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/login`,
        { email, password }
      );

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      Swal.fire("Success", "Login successful", "success").then(() => {
        // navigate("/home");
        window.location.href = "https://globalshospital.com/reminder/home";
      });
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.error || "Login failed",
        "error"
      );
    }
    setLoading(false);
  };

  return (
    <div className="container-fluid login-bg min-vh-100 py-5">
      <div className="row justify-content-center align-items-center h-100">
        <div className="col-12 col-sm-8 col-md-6 col-lg-4">
          <div className="card login-card p-4">
            <h3 className="text-center mb-4 Label">Login</h3>

            <div className="mb-3">
              <label className="form-label mb-2">📧 Email Address</label>
              <input
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
              />
            </div>

            <div className="mb-3">
              <label className="form-label mb-2">🔒 Password</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
              />
            </div>

            <button
              className="btn btn-primary w-100 login-btn fw-bold mt-3"
              onClick={handleLogin}
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
